module.exports = __webpack_public_path__ + "static/media/google-calendar-logo.0b416e63.png";